import React from "react";
import PropTypes from "prop-types";
import {Alert, Typography} from "antd";
import AuthLayoutWrapper from "@web/components/AuthLayoutWrapper";
import useQuerystring from "@web/hooks/useQuerystring";
import {UserContext} from "@web/hooks/context";
import {setDocumentSub} from "@web/lib/firestore.db";
import OauthCompletionStatus from "@web/components/OauthCompletionStatus";
import {notifyAndTrack} from "@web/components/notification";
// import TrelloAuthCallback from "@web/components/TrelloAuthCallback";

const fullWidthStyle = {width: '100%'}
OauthCallback.propTypes = {
  integrationId: PropTypes.string.isRequired,
};

function OauthCallback(props) {
  const [userId] = React.useContext(UserContext);// [app, user, claims
  const params = useQuerystring();
  const [loading, setLoading] = React.useState(false);

  // if (props.integrationId === 'trello-com') return <TrelloAuthCallback integrationId={props.integrationId} />

  const {code, state} = params;
  if (!userId) return null;
  if (!code) return notifyAndTrack.warn('Connect failed', 'Unable to complete your request at this time', {params, code});
  if (!state || state !== userId) return <Alert type="warning">An error occurred</Alert>
  const [integrationId, ...requesterUserIdArray] = state.split(':');
  const requesterUserId = requesterUserIdArray.join(':');
  if (requesterUserId !== userId) return <Alert type="warning">An error occurred</Alert>

  React.useEffect(() => {
    console.log('OauthCallback', params);
    setDocumentSub(["user", userId, 'providers'], integrationId, {code})
      .then(() => setLoading(true));
  }, [code, state]);

  return <AuthLayoutWrapper>
    <Typography.Title level={5} style={{margin: '20px 40px 0'}}>Connecting...</Typography.Title>
    <div className="space-col center middle" style={fullWidthStyle}>
      {loading && <OauthCompletionStatus integrationId={integrationId} userId={userId} />}
    </div>
  </AuthLayoutWrapper>
}

export default OauthCallback;
